export interface MenuItem {
  id: string;
  name: string;
  description: string;
  price: number;
  category: string;
  image?: string;
  available: boolean;
  tags: string[];
}

export interface MenuCategory {
  id: string;
  name: string;
  description?: string;
  sortOrder: number;
}

export interface RestaurantMenu {
  id: string;
  restaurantName: string;
  description: string;
  currency: string;
  categories: MenuCategory[];
  items: MenuItem[];
  updatedAt: string;
}

const STORAGE_KEY = 'restaurant_menu';

export function loadMenu(): RestaurantMenu {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw) as RestaurantMenu;
  } catch { /* ignore */ }
  return {
    id: crypto.randomUUID(),
    restaurantName: 'My Restaurant',
    description: 'Welcome to our restaurant',
    currency: 'USD',
    categories: [
      { id: crypto.randomUUID(), name: 'Appetizers', sortOrder: 0 },
      { id: crypto.randomUUID(), name: 'Main Course', sortOrder: 1 },
      { id: crypto.randomUUID(), name: 'Desserts', sortOrder: 2 },
      { id: crypto.randomUUID(), name: 'Beverages', sortOrder: 3 },
    ],
    items: [],
    updatedAt: new Date().toISOString(),
  };
}

export function saveMenu(m: RestaurantMenu) {
  const updated = { ...m, updatedAt: new Date().toISOString() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  return updated;
}
